import { ENVIRONMENT } from 'src/environments/environment';

export const AmplifyConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: ENVIRONMENT.amplify.awsUserPoolsId,
  aws_user_pools_web_client_id: ENVIRONMENT.amplify.awsUserPoolsWebClientId,
  oauth: {
    domain: ENVIRONMENT.amplify.domain,
  },
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['GIVEN_NAME', 'EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};
